// extracted by mini-css-extract-plugin
export var adCard = "_oc-8";
export var adCardBorder = "_oc-5";
export var arbiterButtonIcon = "_oc-p";
export var buttonIcon = "_oc-o";
export var container = "_oc-e";
export var copyButton = "_oc-m";
export var darkGrey = "_oc-u";
export var deliveryDate = "_oc-2";
export var divider = "_oc-n";
export var editModeWrapper = "_oc-7";
export var empty = "_oc-a";
export var errorIcon = "_oc-d";
export var filledCircle = "_oc-4";
export var fulfillmentFooter = "_oc-j";
export var grey = "_oc-s";
export var header = "_oc-i";
export var headerWrapper = "_oc-h";
export var highlighted = "_oc-6";
export var historyEntry = "_oc-3";
export var mobileColumn = "_oc-v";
export var mobileColumnReverse = "_oc-w";
export var orderDetailsContainer = "_oc-g";
export var orderMetadata = "_oc-l";
export var orderMetadataWrapper = "_oc-k";
export var packagesContainer = "_oc-b";
export var product = "_oc-y";
export var productImage = "_oc-z";
export var productInfo = "_oc-x";
export var productTitle = "_oc-10";
export var strikethrough = "_oc-t";
export var tinyText = "_oc-r";
export var title = "_oc-9";
export var trackerCard = "_oc-1";
export var trackerCardWrapper = "_oc-0";
export var trackingContainer = "_oc-f";
export var trackingTitle = "_oc-c";
export var xTinyText = "_oc-q";